module.exports = __webpack_public_path__ + "img/slide_4.ee6248c0.jpg";